// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"718":"5f769ec2","960":"7e5f9df5"}[chunkId] + ".css";
};